export default __webpack_public_path__ + "assets/672e019c59a9e5c9c598101d1fa6b5b9.png";